import { forwardRef } from "react"
import PropTypes from "prop-types"
import { get, map, noop } from "lodash"
import { Grid, IconButton } from "@mui/material"
import { ExpandMore } from "@mui/icons-material"
import Ellipsable from "components/ellipsable"
import classNames from "classnames"

const TitleRow = forwardRef(({ label, values, valueClassNames, color, fixed, onClick, getColumnColorStyle = noop, maxLabelWidth, ToggleAllButton }, ref) => {
  return (
    <Grid container className="factor-row title-row" onClick={onClick}>
      <Grid ref={ref} container className="factor-label" sx={{ width: "100%" }}>
        <span className="label" style={{ color }}>
          <Ellipsable width={maxLabelWidth}>{label}</Ellipsable>
        </span>
        {!fixed && <span className="buttons">
          {ToggleAllButton}
          <IconButton size="small" className="expand-icon"><ExpandMore /></IconButton>
        </span>}
      </Grid>
      <Grid container className="values" sx={{ width: "100%" }}>
        {map(values, (value, index) => <div key={`title-row-value-${index}`} className={classNames("value", get(valueClassNames, index, ""))} style={getColumnColorStyle(index)}>
          {value}
        </div>,
        )}
      </Grid>
    </Grid>
  )
})

TitleRow.propTypes = {
  label: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  valueClassNames: PropTypes.array,
  color: PropTypes.string.isRequired,
  fixed: PropTypes.bool,
  onClick: PropTypes.func,
  getColumnColorStyle: PropTypes.func,
  maxLabelWidth: PropTypes.number,
  ToggleAllButton: PropTypes.element.isRequired,
}

TitleRow.displayName = "TitleRow"

export default TitleRow
